package com.raouf.mehrguard.web.i18n

internal val ArabicStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "كاشف التصيد عبر QR متعدد المنصات",
    WebStringKey.MenuMain to "القائمة الرئيسية",
    WebStringKey.MenuSecurity to "الأمان",
    WebStringKey.MenuSystem to "النظام",
    WebStringKey.NavDashboard to "لوحة التحكم",
    WebStringKey.NavScanMonitor to "مراقب المسح",
    WebStringKey.NavScanHistory to "سجل المسح",
    WebStringKey.NavTrustCentre to "مركز الثقة",
    WebStringKey.NavReports to "التقارير",
    WebStringKey.NavTraining to "التدريب",
    WebStringKey.NavSettings to "الإعدادات",
    WebStringKey.QuickActions to "إجراءات سريعة",

    // Hero Section
    WebStringKey.HeroTagline to "آمن. غير متصل.",
    WebStringKey.HeroTagline2 to "دفاع قابل للتفسير.",
    WebStringKey.HeroDescription to "يحلل Mehr Guard التهديدات المحتملة مباشرة على جهازك. استمتع بحماية بدون تأخير.",

    // Dashboard
    WebStringKey.StartScan to "بدء مسح جديد",
    WebStringKey.ImportImage to "استيراد صورة",
    WebStringKey.ScanQrCode to "مسح رمز QR",
    WebStringKey.SystemHealth to "صحة النظام",
    WebStringKey.ThreatDatabase to "قاعدة بيانات التهديدات",
    WebStringKey.Current to "الحالي",
    WebStringKey.Active to "نشط",
    WebStringKey.Threats to "التهديدات",
    WebStringKey.SafeScans to "المسوحات الآمنة",
    WebStringKey.EngineActive to "المحرك نشط",
    WebStringKey.EnterpriseProtection to "حماية المؤسسة نشطة",
    WebStringKey.SystemOptimal to "النظام مثالي",
    WebStringKey.EngineStatus to "المحرك v2.4 • تحديث منذ ساعتين",
    WebStringKey.ThreatsBlocked to "تهديدات محظورة",
    WebStringKey.AllSystemsOperational to "جميع الأنظمة تعمل",

    // Dashboard Sections
    WebStringKey.SectionOverview to "نظرة عامة",
    WebStringKey.SectionSecurity to "الأمان",
    WebStringKey.SectionTraining to "التدريب",
    WebStringKey.SectionReports to "التقارير",
    WebStringKey.OfflineReady to "جاهز للعمل بدون اتصال",
    WebStringKey.OfflineDescription to "قاعدة البيانات المحلية v2.4.1 نشطة. لا تغادر أي بيانات هذا الجهاز.",
    
    // Trust Centre
    WebStringKey.TrustCentreTitle to "مركز الثقة",
    WebStringKey.OfflineGuarantee to "ضمان صارم للعمل دون اتصال",
    WebStringKey.OfflineGuaranteeDesc to "يعمل تحليل Mehr Guard بالكامل على محرك Neural Engine في جهازك. لا تغادر بيانات URL هاتفك أبداً.",
    WebStringKey.ThreatSensitivity to "حساسية التهديدات",
    WebStringKey.ResetConfirm to "سيؤدي هذا إلى إعادة تعيين جميع إعدادات مركز الثقة إلى الإعدادات الافتراضية.",
    
    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "مراقب التهديدات",
    WebStringKey.ThreatMonitorDesc to "عرض التهديدات الحية وتشغيل تدقيق الأمان",
    WebStringKey.TrustCentreDesc to "إعدادات الخصوصية وحساسية التهديدات",
    WebStringKey.ExportReport to "تصدير التقرير",
    WebStringKey.ExportReportDesc to "إنشاء تقرير أمان PDF أو JSON",

    // Dashboard Content
    WebStringKey.Analyze to "تحليل",
    WebStringKey.HeuristicEngine to "المحرك الإستدلالي",
    WebStringKey.HighPerformanceEngine to "محرك عالي الأداء",
    WebStringKey.RecentScans to "المسوحات الأخيرة",
    WebStringKey.ViewFullHistory to "عرض السجل الكامل",
    WebStringKey.Status to "الحالة",
    WebStringKey.Source to "المصدر",
    WebStringKey.Details to "التفاصيل",
    WebStringKey.Time to "الوقت",
    WebStringKey.Version to "الإصدار",
    WebStringKey.LastUpdate to "آخر تحديث",
    WebStringKey.Signatures to "التوقيعات",
    WebStringKey.CheckForUpdates to "التحقق من التحديثات",
    WebStringKey.FeatureOfflineTitle to "بنية الأولوية للوضع غير المتصل",
    WebStringKey.FeatureOfflineDesc to "يتم إجراء التحليل الكامل محلياً. لا تصل بيانات الكاميرا والبيانات الممسوحة أبداً إلى خادم خارجي، مما يضمن الخصوصية المطلقة.",
    WebStringKey.FeatureExplainableTitle to "الأمان القابل للتفسير",
    WebStringKey.FeatureExplainableDesc to "لا تحصل فقط على \"حظر\". نقدم تحليلات استدلالية مفصلة لمعلمات URL والتحويلات وحمولات JavaScript.",
    WebStringKey.FeaturePerformanceDesc to "محسّن لبيئات سطح المكتب. تتم معالجة المسوحات في أقل من 5 مللي ثانية باستخدام ثنائيات Kotlin Multiplatform الأصلية.",
    WebStringKey.TrainingCentre to "مركز التدريب",
    WebStringKey.LearnHomograph to "تعلم كيفية التعرف على هجمات QR المتقدمة بالأحرف المتشابهة.",
    WebStringKey.BeatTheBotAction to "تغلب على الروبوت →",
    WebStringKey.NoScansYet to "لا توجد مسوحات حتى الآن. ابدأ مسحاً جديداً لرؤية النتائج هنا.",
    WebStringKey.VerdictSafe to "آمن",
    WebStringKey.VerdictPhish to "تصيد",
    WebStringKey.VerdictWarn to "تحذير",
    WebStringKey.ScoreLabel to "النتيجة:",

    // Scanner
    WebStringKey.ActiveScanner to "الماسح النشط",
    WebStringKey.OfflineMode to "الوضع غير المتصل",
    WebStringKey.LiveFeedDisconnected to "البث المباشر منقطع",
    WebStringKey.CameraAccessRequired to "مطلوب الوصول للكاميرا",
    WebStringKey.CameraAccessDescription to "اسحب وأفلت صورة رمز QR هنا أو قم بتمكين الوصول إلى الكاميرا لبدء المسح.",
    WebStringKey.EnableCamera to "تمكين الكاميرا",
    WebStringKey.Scanning to "جاري المسح...",
    WebStringKey.ScanHint to "أبقِ الرمز ثابتاً. تم التحليل بدون اتصال في <5 مللي ثانية.",
    WebStringKey.Torch to "المصباح",
    WebStringKey.Gallery to "المعرض",
    WebStringKey.PasteUrl to "لصق URL",
    WebStringKey.PasteUrlTitle to "الصق URL للتحليل",
    WebStringKey.AnalyzeUrl to "تحليل URL",
    WebStringKey.SystemStatus to "حالة النظام",
    WebStringKey.PhishingEngine to "محرك التصيد",
    WebStringKey.Ready to "جاهز",
    WebStringKey.LocalDb to "قاعدة بيانات محلية",
    WebStringKey.Latency to "التأخير",
    WebStringKey.ViewAll to "عرض الكل",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "الرئيسية",
    WebStringKey.BreadcrumbScans to "المسوحات",
    WebStringKey.OfflineProtection to "حماية بدون اتصال",
    WebStringKey.VerdictHighRisk to "تم اكتشاف خطر عالٍ",
    WebStringKey.VerdictDangerous to "خطير",
    WebStringKey.VerdictDangerousDesc to "يحتوي رمز QR الممسوح على مؤشرات ضارة مرتبطة بالتصيد الاحتيالي وجمع بيانات الاعتماد. لا تتابع إلى عنوان URL المستهدف.",
    WebStringKey.ThreatConfidence to "ثقة التهديد",
    WebStringKey.FlagPhishing to "محاولة تصيد",
    WebStringKey.FlagObfuscated to "نص برمجي مشفر",
    WebStringKey.FlagHomograph to "هجوم الأحرف المتشابهة",
    WebStringKey.ClearHistory to "مسح الكل",
    WebStringKey.SectionAttackBreakdown to "تحليل الهجوم",
    WebStringKey.AttackHomographTitle to "هجوم الأحرف المتشابهة / IDN",
    WebStringKey.AttackHomographDesc to "تم اكتشاف أحرف سيريلية تحاكي الأبجدية اللاتينية.",
    WebStringKey.AttackVisualLabel to "المظهر المرئي",
    WebStringKey.AttackPunycodeLabel to "Punycode الفعلي",
    WebStringKey.AttackHomographExplain to "يستخدم النطاق الحرف السيريلي 'а' (U+0430) بدلاً من الحرف اللاتيني 'a' (U+0061). تُستخدم هذه التقنية عادةً لخداع المستخدمين ليعتقدوا أنهم يزورون خدمة شرعية.",
    WebStringKey.AttackRedirectTitle to "سلسلة تحويلات مشبوهة",
    WebStringKey.AttackRedirectDesc to "تم اكتشاف 3 قفزات تتضمن مختصرات URL معروفة.",
    WebStringKey.RedirectStart to "مسح رمز QR",
    WebStringKey.RedirectHop to "قفزة وسيطة",
    WebStringKey.RedirectFinal to "الوجهة النهائية",
    WebStringKey.AttackJsTitle to "JavaScript مشفر",
    WebStringKey.AttackJsDesc to "تم اكتشاف سلسلة عالية الإنتروبيا في معلمات URL.",
    WebStringKey.SectionActions to "الإجراءات الموصى بها",
    WebStringKey.ActionBlock to "حظر والإبلاغ",
    WebStringKey.ActionBlockDesc to "منع الوصول وإخطار المسؤول",
    WebStringKey.ActionQuarantine to "عزل في Sandbox",
    WebStringKey.ActionQuarantineDesc to "فتح بأمان للتحليل",
    WebStringKey.Expected to "المتوقع: ",
    WebStringKey.Detected to "المكتشف: ",
    WebStringKey.ExplainableSecurity to "أمان قابل للتفسير",
    WebStringKey.UrlBreakdown to "تفصيل الرابط",
    WebStringKey.FullUrl to "الرابط الكامل",
    WebStringKey.OpenInBrowser to "فتح في المتصفح (محفوف بالمخاطر)",
    WebStringKey.OpenWarning to "قد يعرضك فتح هذا الرابط في متصفحك لمخاطر أمنية.",
    WebStringKey.RestrictedMode to "وضع مقيد",
    WebStringKey.RestrictedDesc to "تم تصنيف هذا الرابط على أنه خطير محتمل. راجع التحليل أدناه قبل المتابعة.",
    WebStringKey.DangerousWarning to "تم تصنيف هذا الرابط على أنه خطير محتمل. قد يعرضك فتحه للتصيد أو البرامج الضارة أو تهديدات أمنية أخرى. هل أنت متأكد أنك تريد المتابعة؟",
    WebStringKey.CopyUrl to "نسخ الرابط",
    WebStringKey.Share to "مشاركة",
    WebStringKey.Dismiss to "إغلاق",
    WebStringKey.ReasonDomainAge to "عمر النطاق أقل من 24 ساعة.",
    WebStringKey.ReasonSignatures to "تطابق مع 3 توقيعات في قاعدة بيانات التصيد المحلية.",
    WebStringKey.ReasonAsn to "عنوان IP الهدف موجود في ASN عالي الخطورة.",
    WebStringKey.SectionMeta to "بيانات المسح الوصفية",
    WebStringKey.MetaTime to "وقت المسح",
    WebStringKey.MetaSource to "المصدر",
    WebStringKey.MetaEngine to "المحرك",
    WebStringKey.MetaOfflineGuaranteeLabel to "ضمان العمل بدون اتصال:",
    WebStringKey.MetaOfflineGuaranteeDesc to "تم تحليل هذه الصورة محلياً على جهازك. لم يتم إرسال أي بيانات إلى السحابة لهذا الحكم.",
    
    // Results Page
    WebStringKey.ScanComplete to "اكتمل المسح",
    WebStringKey.Loading to "جاري التحميل...",
    WebStringKey.AnalyzedOffline to "تم التحليل بدون اتصال في أقل من 5 مللي ثانية",
    WebStringKey.NoDataLeaves to "لا تغادر أي بيانات الجهاز",
    WebStringKey.ActiveProtection to "حماية نشطة",
    WebStringKey.ConfidenceScore to "درجة الثقة",
    WebStringKey.Analyzing to "جاري التحليل...",
    WebStringKey.ProcessingResults to "جاري معالجة نتائج المسح...",
    WebStringKey.RiskAssessment to "تقييم المخاطر",
    WebStringKey.AnalysisTime to "وقت التحليل",
    WebStringKey.Heuristics to "الاستدلالات",
    WebStringKey.TopAnalysisFactors to "أهم عوامل التحليل",
    WebStringKey.Pass to "ناجح",
    WebStringKey.Info to "معلومات",
    WebStringKey.Clean to "نظيف",
    WebStringKey.ValidSslCertificate to "شهادة SSL صالحة",
    WebStringKey.SslCertificateDesc to "شهادة صادرة من DigiCert Inc. لا توجد شذوذات في سلسلة الثقة.",
    WebStringKey.EstablishedDomain to "نطاق راسخ",
    WebStringKey.EstablishedDomainDesc to "تم تسجيل النطاق منذ أكثر من 5 سنوات. احتمال منخفض للاحتيال.",
    WebStringKey.BlacklistStatus to "حالة القائمة السوداء",
    WebStringKey.BlacklistStatusDesc to "غير موجود في 52 قاعدة بيانات تهديدات محلية.",
    WebStringKey.BackToDashboard to "العودة إلى لوحة التحكم",
    WebStringKey.ShareReport to "مشاركة التقرير",
    WebStringKey.CopyLink to "نسخ الرابط",
    WebStringKey.LinkCopied to "تم نسخ الرابط إلى الحافظة!",
    
    // Game Page
    WebStringKey.BeatTheBot to "تغلب على الروبوت",
    WebStringKey.BeatTheBotDesc to "تحدى محرك الذكاء الاصطناعي. هل يمكنك اكتشاف التصيد أسرع؟",
    WebStringKey.SessionId to "معرّف الجلسة",
    WebStringKey.EndSession to "إنهاء الجلسة",
    WebStringKey.Round to "الجولة",
    WebStringKey.BrowserPreview to "معاينة المتصفح",
    WebStringKey.MakeDecision to "اتخذ قرارك",
    WebStringKey.Phishing to "تصيد",
    WebStringKey.Legitimate to "شرعي",
    WebStringKey.LiveHint to "تلميح مباشر",
    WebStringKey.LiveScoreboard to "لوحة النتائج المباشرة",
    WebStringKey.VsMode to "وضع المقابلة",
    WebStringKey.You to "أنت",
    WebStringKey.Points to "نقطة",
    WebStringKey.Streak to "سلسلة",
    WebStringKey.Accuracy to "الدقة",
    WebStringKey.MehrGuardBot to "روبوت Mehr Guard",
    WebStringKey.Confidence to "الثقة",
    WebStringKey.RoundAnalysis to "تحليل الجولة",
    WebStringKey.Analysis to "تحليل",
    WebStringKey.CorrectDecision to "قرار صحيح!",
    WebStringKey.IdentifiedSafe to "لقد حددت الرابط الآمن بشكل صحيح.",
    WebStringKey.AiNeuralAnalysis to "تحليل الشبكة العصبية",
    WebStringKey.WhyBotFlagged to "لماذا صنفه الروبوت",
    WebStringKey.EducationalNote to "ملاحظة تعليمية",
    WebStringKey.Correct to "صحيح!",
    WebStringKey.SpottedPhishing to "لقد اكتشفت رابط التصيد بشكل صحيح.",
    WebStringKey.Response to "الاستجابة",
    WebStringKey.NextRound to "الجولة التالية",
    WebStringKey.GameOver to "انتهت اللعبة!",
    WebStringKey.FinalResults to "النتائج النهائية",
    WebStringKey.YourScore to "نتيجتك",
    WebStringKey.BotScore to "نتيجة الروبوت",
    WebStringKey.BestStreak to "أفضل سلسلة",
    WebStringKey.PlayAgain to "العب مجدداً",
    WebStringKey.ReturnToDashboard to "العودة إلى لوحة التحكم",
    
    // Export Page
    WebStringKey.ExportSecurityReport to "تصدير تقرير الأمان",
    WebStringKey.GenerateReport to "إنشاء تقارير أمان شاملة من سجل المسح الخاص بك.",
    WebStringKey.ReportFormat to "تنسيق التقرير",
    WebStringKey.HumanReadable to "تقرير قابل للقراءة",
    WebStringKey.HumanReadableDesc to "PDF مع تفصيل مرئي وملخص تنفيذي",
    WebStringKey.MachineReadable to "بيانات قابلة للقراءة الآلية",
    WebStringKey.MachineReadableDesc to "تنسيق JSON للتكامل مع أدوات SIEM",
    WebStringKey.DateRange to "نطاق التاريخ",
    WebStringKey.Last7Days to "آخر 7 أيام",
    WebStringKey.Last30Days to "آخر 30 يوم",
    WebStringKey.Last90Days to "آخر 90 يوم",
    WebStringKey.AllTime to "كل الوقت",
    WebStringKey.CustomRange to "نطاق مخصص",
    WebStringKey.ReportSections to "أقسام التقرير",
    WebStringKey.ExecutiveSummary to "الملخص التنفيذي",
    WebStringKey.ThreatBreakdown to "تفصيل التهديدات",
    WebStringKey.ScanTimeline to "الجدول الزمني للمسح",
    WebStringKey.SafeUrlList to "قائمة الروابط الآمنة",
    WebStringKey.GenerateExport to "تصدير التقرير",
    
    // Toast / Notifications
    WebStringKey.Success to "نجاح!",
    WebStringKey.Error to "خطأ",
    WebStringKey.Warning to "تحذير",
    WebStringKey.CopiedToClipboard to "تم النسخ إلى الحافظة",
    
    // General Actions
    WebStringKey.Cancel to "إلغاء",
    WebStringKey.Confirm to "تأكيد",
    WebStringKey.Save to "حفظ",
    WebStringKey.Delete to "حذف",
    WebStringKey.Edit to "تعديل",
    WebStringKey.Close to "إغلاق",
    WebStringKey.Back to "رجوع",
    WebStringKey.Next to "التالي",
    WebStringKey.Previous to "السابق",
    WebStringKey.Submit to "إرسال",
    WebStringKey.Reset to "إعادة تعيين",
    WebStringKey.Clear to "مسح",
    WebStringKey.Search to "بحث",
    WebStringKey.Filter to "تصفية",
    WebStringKey.Sort to "فرز",
    
    // Accessibility
    WebStringKey.ToggleMenu to "تبديل القائمة",
    WebStringKey.ToggleTheme to "تبديل السمة",
    WebStringKey.Notifications to "الإشعارات",
    WebStringKey.Help to "مساعدة",
    WebStringKey.Profile to "الملف الشخصي",
    WebStringKey.ToggleLightDarkMode to "تبديل الوضع الفاتح/الداكن",
    
    // Placeholders
    WebStringKey.UrlInputPlaceholder to "الصق الرابط للتحليل (مثال: https://example.com)",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    
    // Export Page Additional
    WebStringKey.Scan to "مسح",
    WebStringKey.Result to "نتيجة",
    WebStringKey.ReportGeneration to "إنشاء التقرير",
    WebStringKey.ReportGenerationDesc to "تكوين التنسيقات وتحميل تحليل التهديدات الخاص بك.",
    WebStringKey.OfflineSecurity to "أمان بدون اتصال",
    WebStringKey.OfflineSecurityDesc to "لا تغادر بياناتك هذا الجهاز أبداً. كل المعالجة محلية. بدون تتبع، بدون رفع.",
    WebStringKey.ChooseFormat to "اختر التنسيق",
    WebStringKey.PdfFormatDesc to "تنسيق PDF. الأفضل للمشاركة مع أصحاب المصلحة.",
    WebStringKey.JsonFormatDesc to "تنسيق JSON. الأفضل لتكامل SIEM.",
    WebStringKey.Copy to "نسخ",
    WebStringKey.LivePreview to "معاينة مباشرة",
    WebStringKey.ReadOnly to "للقراءة فقط",
    WebStringKey.ThreatAnalysisReport to "تقرير تحليل التهديدات",
    WebStringKey.Verdict to "الحكم",
    WebStringKey.RiskScore to "درجة المخاطر",
    WebStringKey.TargetUrl to "الرابط المستهدف",
    WebStringKey.AnalysisSummaryLabel to "ملخص التحليل",
    WebStringKey.TechnicalIndicators to "المؤشرات التقنية",
    WebStringKey.ExportInfoNote to "تتضمن التصديرات جميع متجهات التهديد المحددة والعناوين وتحليل الحمولة الخام.",
    
    // Trust Centre Page
    WebStringKey.AllowList to "قائمة السماح",
    WebStringKey.BlockList to "قائمة الحظر",
    WebStringKey.AddDomain to "إضافة نطاق",
    WebStringKey.RemoveDomain to "إزالة نطاق",
    WebStringKey.TrustedDomains to "النطاقات الموثوقة",
    WebStringKey.BlockedDomains to "النطاقات المحظورة",
    WebStringKey.DomainPlaceholder to "أدخل النطاق (مثال: example.com)",
    
    // Game Page Additional
    WebStringKey.Safe to "آمن",
    WebStringKey.TimeAgo to "منذ",
    WebStringKey.MinutesAgo to "دقائق مضت",
    WebStringKey.HoursAgo to "ساعات مضت",
    
    // Misc
    WebStringKey.Critical to "حرج",
    WebStringKey.Warn to "تحذير",
    
    // Trust Centre - Sensitivity
    WebStringKey.PhishingDetectionSensitivity to "حساسية اكتشاف التصيد",
    WebStringKey.SensitivityDescription to "اضبط عتبات الاستدلال. قد تزيد الحساسية العالية من الإيجابيات الخاطئة.",
    WebStringKey.SensitivityLow to "منخفض",
    WebStringKey.SensitivityBalanced to "متوازن",
    WebStringKey.SensitivityParanoia to "بارانويا",
    WebStringKey.BalancedModeRecommended to "الوضع المتوازن (موصى به)",
    WebStringKey.BalancedModeDesc to "يفحص الأنماط الخبيثة المعروفة وعدم التطابق الاستدلالي. يحظر هجمات الأحرف المتشابهة وسلاسل إعادة التوجيه. معدل إيجابي خاطئ منخفض متوقع.",
    WebStringKey.LowSensitivityMode to "وضع الحساسية المنخفضة",
    WebStringKey.LowSensitivityModeDesc to "يحظر فقط عناوين URL الخبيثة المعروفة من قاعدة بيانات التهديدات. أدنى معدل إيجابي خاطئ، لكن قد يفوت الهجمات الجديدة.",
    WebStringKey.ParanoiaMode to "وضع البارانويا",
    WebStringKey.ParanoiaModeDesc to "أقصى حماية. يحظر أي أنماط مشبوهة بما في ذلك النطاقات المسجلة حديثاً، TLDs غير المألوفة، وأي URL مع حيل ترميز محتملة.",
    WebStringKey.PrivacyGuaranteeDesc to "يستخدم Mehr Guard محركات تحليل استدلالية محلية. لا تغادر أي بيانات صور أو سلاسل URL أو بيانات وصفية هذا الجهاز أثناء الفحص. خصوصيتك مضمونة رياضياً.",
    WebStringKey.SignalBrandImpersonation to "تم اكتشاف انتحال محتمل للعلامة التجارية",
    WebStringKey.SignalCredentialParams to "معلمات متعلقة ببيانات الاعتماد في URL",
    WebStringKey.SignalEncodedPayload to "تم اكتشاف بيانات مشفرة في معلمات الاستعلام",
    WebStringKey.SignalExcessiveSubdomains to "عمق نطاق فرعي مفرط ({count} مستويات)",
    WebStringKey.SignalHighEntropyHost to "عشوائية عالية في اسم النطاق",
    WebStringKey.SignalHomographAttack to "النطاق يحتوي على أحرف متشابهة/قابلة للخلط",
    WebStringKey.SignalHttpNotHttps to "يستخدم بروتوكول HTTP غير الآمن",
    WebStringKey.SignalIpAddressHost to "المضيف هو عنوان IP بدلاً من نطاق",
    WebStringKey.SignalLongUrl to "URL طويل بشكل غير عادي ({length} حرف)",
    WebStringKey.SignalLongUrlMarketing to "URL طويل بشكل غير عادي ({length} حرف) - يحتوي على معلمات تسويقية",
    WebStringKey.SignalNewlyRegisteredDomain to "تم اكتشاف نطاق مسجل حديثاً",
    WebStringKey.SignalNonStandardPort to "منفذ غير قياسي: {port}",
    WebStringKey.SignalNumericSubdomain to "تم اكتشاف نطاق فرعي رقمي فقط",
    WebStringKey.SignalSuspiciousPathKeywords to "كلمات مفتاحية مشبوهة في المسار ({count} وجدت)",
    WebStringKey.SignalSuspiciousTld to "TLD مشبوه: {tld}",
    WebStringKey.SignalUrlShortener to "يستخدم خدمة تقصير URL",
    WebStringKey.SecureEnvironment to "بيئة آمنة",
    WebStringKey.LearnLocalArchitecture to "تعرف على بنيتنا المحلية",
    WebStringKey.NoCustomDomainsBlocked to "لا توجد نطاقات مخصصة محظورة.",
    WebStringKey.AddManually to "إضافة يدوياً",
    WebStringKey.AddedDaysAgo to "أضيف منذ يومين",
    WebStringKey.AddedWeekAgo to "أضيف منذ أسبوع",
    
    // Trust Centre - Privacy Controls
    WebStringKey.PrivacyControls to "ضوابط الخصوصية",
    WebStringKey.StrictOfflineMode to "وضع صارم بدون اتصال",
    WebStringKey.DisableExternalPreviews to "تعطيل جميع معاينات الروابط الخارجية.",
    WebStringKey.AnonymousTelemetry to "القياس عن بعد المجهول",
    WebStringKey.ShareDetectionStats to "مشاركة إحصائيات الاكتشاف لتحسين التعلم الآلي.",
    WebStringKey.AutoCopySafeLinks to "نسخ الروابط الآمنة تلقائياً",
    WebStringKey.CopyTrustedUrls to "نسخ الروابط الموثوقة إلى الحافظة.",
    
    // Trust Centre - About
    WebStringKey.AboutMehrGuard to "حول Mehr Guard",
    WebStringKey.OpenSourceLicenses to "تراخيص المصدر المفتوح",
    WebStringKey.PrivacyPolicy to "سياسة الخصوصية",
    WebStringKey.Acknowledgements to "شكر وتقدير",
    WebStringKey.ResetAllSettings to "إعادة تعيين جميع الإعدادات إلى الافتراضي",
    WebStringKey.AddToAllowlist to "إضافة إلى قائمة السماح",
    WebStringKey.AddToBlocklist to "إضافة إلى قائمة الحظر",
    
    // Onboarding
    WebStringKey.AnalysedOfflineTitle to "تم التحليل بدون اتصال.",
    WebStringKey.YourDataStaysOnDevice to "تبقى بياناتك على جهازك.",
    WebStringKey.OnboardingHeroDesc to "يعالج Mehr Guard كل مسح باستخدام تحليل آمن على الجهاز. نعطي الأولوية للأمان القابل للتفسير مع عدم وجود قياس عن بعد سحابي لتحليل الصور.",
    WebStringKey.OnDeviceAnalysis to "تحليل على الجهاز",
    WebStringKey.OnDeviceAnalysisDesc to "يعمل كل اكتشاف للتهديدات محلياً على جهازك. لا تغادر أي بيانات نظامك أبداً.",
    WebStringKey.NoCloudLogs to "لا سجلات سحابية",
    WebStringKey.NoCloudLogsDesc to "نعطل بصرامة القياس عن بعد الصادر للمسوحات. تبقى نتائج المسح وتجزئات الصور محلية.",
    WebStringKey.OnDeviceDB to "قاعدة بيانات على الجهاز",
    WebStringKey.OnDeviceDBDesc to "يتم تحميل قاعدة بيانات توقيعات التهديدات بالكامل إلى جهازك للبحث بالمللي ثانية.",
    WebStringKey.DataLifecycleVerification to "التحقق من دورة حياة البيانات",
    WebStringKey.SecurityAuditPass to "تدقيق الأمان: ناجح",
    
    // Footer
    WebStringKey.Copyright to "© 2024 Mehr Guard Security Inc. جميع الحقوق محفوظة.",
    WebStringKey.Support to "الدعم",
    WebStringKey.Terms to "الشروط",
    WebStringKey.SystemsOperational to "الأنظمة تعمل",
    WebStringKey.SystemSecure to "النظام آمن",
    
    // Version / Build Info
    WebStringKey.VersionStatus to "v2.4.1 • النظام آمن",
    WebStringKey.CoreVersion to "الإصدار الأساسي v2.4.1 • بناء 2024.12.19",
    WebStringKey.VerifiedBy to "تم التحقق بواسطة Mehr Guard Enterprise",
    
    // User Profile (Sample)
    WebStringKey.SampleUserName to "جون سميث",
    WebStringKey.SampleUserRole to "محلل أمني",
    
    // Export Preview
    WebStringKey.DetailLabel to "تفاصيل العنوان",
    WebStringKey.DetailValue to "قيمة التفاصيل",
    WebStringKey.Suspicious to "مشبوه",
    
    // Game Modal Strings
    WebStringKey.IncorrectDecision to "قرار خاطئ",
    WebStringKey.WrongAnswer to "عذراً! لم يكن ذلك صحيحاً.",
    WebStringKey.ResponseTime to "وقت الاستجابة",
    WebStringKey.IncomingMessage to "رسالة واردة",
    WebStringKey.CertificateIssuer to "مُصدر الشهادة يطابق مالك النطاق",
    WebStringKey.DomainAgeTrust to "عمر النطاق > 5 سنوات (ثقة عالية)",
    WebStringKey.WhitelistedRank to "ضمن أفضل 1000 في Alexa مدرج في القائمة البيضاء محلياً",
    
    // Game Tips/Hints
    WebStringKey.GameEducationalNote to "ملاحظة تعليمية",
    WebStringKey.GameHintTitle to "تلميح اللعبة",
    
    // Trust Modal
    WebStringKey.AddToAllowlistTitle to "إضافة إلى قائمة السماح",
    WebStringKey.AddToBlocklistTitle to "إضافة إلى قائمة الحظر",
    WebStringKey.EnterDomainPrompt to "أدخل نطاقاً لإضافته إلى قائمتك",
    
    // Additional Game Strings
    WebStringKey.LatencyMs to "زمن الاستجابة",
    WebStringKey.StreakFire to "السلسلة",
    WebStringKey.AccuracyPercent to "الدقة",
    WebStringKey.ConfidencePercent to "الثقة",
    
    // Languages
    WebStringKey.English to "الإنجليزية",
    WebStringKey.German to "الألمانية",
    WebStringKey.Spanish to "الإسبانية",
    WebStringKey.French to "الفرنسية",
    WebStringKey.ChineseSimplified to "الصينية المبسطة",
    WebStringKey.Japanese to "اليابانية",
    WebStringKey.Hindi to "الهندية",
    WebStringKey.Arabic to "العربية",
    WebStringKey.Indonesian to "الإندونيسية",
    WebStringKey.Italian to "الإيطالية",
    WebStringKey.Korean to "الكورية",
    WebStringKey.Portuguese to "البرتغالية",
    WebStringKey.Russian to "الروسية",
    WebStringKey.Thai to "التايلاندية",
    WebStringKey.Turkish to "التركية",
    WebStringKey.Vietnamese to "الفيتنامية"
,
    WebStringKey.ComponentVoting to "تصويت المكونات",
    WebStringKey.Heuristic to "التحليل الاستكشافي",
    WebStringKey.MLModel to "نموذج التعلم الآلي",
    WebStringKey.Brand to "العلامة التجارية",
    WebStringKey.TLD to "نطاق المستوى الأعلى",
    WebStringKey.VotingExplanation to "التصويت بالأغلبية يحدد الحكم: 3+ آمن = أخضر، 2+ ضار = أحمر"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "في انتظار المسح...",
    WebStringKey.WaitingForAnalysis to "في انتظار التحليل...",
    WebStringKey.ScanURLToSeeResults to "امسح رابطًا لرؤية النتائج التفصيلية.",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "اختصارات لوحة المفاتيح",
    WebStringKey.StartScanner to "بدء الماسح",
    WebStringKey.CloseMenuModal to "إغلاق القائمة / النافذة",
    WebStringKey.NavigateToDashboard to "الانتقال إلى لوحة التحكم",
    WebStringKey.NavigateToHistory to "سجل المسح",
    WebStringKey.NavigateToTrust to "مركز الثقة / قائمة السماح",
    WebStringKey.NavigateToGame to "لعبة تغلب على الروبوت",
    WebStringKey.ShowHelp to "عرض المساعدة",
    WebStringKey.GotIt to "فهمت",
    WebStringKey.SecuritySettings to "إعدادات الأمان",
    WebStringKey.SensitivityLevel to "مستوى الحساسية",
    WebStringKey.AutoBlockThreats to "حظر التهديدات تلقائيًا",
    WebStringKey.RealTimeScanning to "المسح في الوقت الفعلي",
    WebStringKey.SoundAlerts to "تنبيهات صوتية",
    WebStringKey.ThreatAlerts to "تنبيهات التهديدات",
    WebStringKey.ShowConfidenceScore to "عرض درجة الثقة",
    WebStringKey.CompactView to "عرض مضغوط",
    WebStringKey.ResetDefaults to "إعادة تعيين الافتراضيات",
    WebStringKey.SaveAndContinue to "حفظ والمتابعة",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "حول Mehr Guard Security",
    WebStringKey.ActualDomain to "النطاق الفعلي",
    WebStringKey.AnalysisComplete to "اكتمل التحليل",
    WebStringKey.AutoBlockThreatsDesc to "حظر التهديدات تلقائياً",
    WebStringKey.AwaitingScanLabel to "في انتظار المسح",
    WebStringKey.BrandImpersonation to "انتحال العلامة التجارية",
    WebStringKey.CautionAdvised to "يُنصح بالحذر",
    WebStringKey.CompactViewDesc to "العرض المدمج",
    WebStringKey.DoNotVisit to "لا تقم بالزيارة",
    WebStringKey.DoNotVisitDesc to "تم اكتشاف تصيد احتيالي بثقة عالية. يُظهر هذا الرابط مؤشرات خبيثة متعددة.",
    WebStringKey.DomainUsesInternationalChars to "يستخدم هذا النطاق أحرفاً دولية قد تحاكي النطاقات المشروعة.",
    WebStringKey.GoToScanner to "الذهاب إلى الماسح",
    WebStringKey.Hebrew to "العبرية",
    WebStringKey.HelpKeyboardShortcuts to "اختصارات لوحة المفاتيح",
    WebStringKey.HeuristicAnalysis to "التحليل الاستدلالي",
    WebStringKey.HeuristicAnalysisDesc to "تم وضع علامة على الرابط بناءً على عوامل خطر متعددة اكتشفها محرك التحليل.",
    WebStringKey.HiddenDestination to "الوجهة المخفية",
    WebStringKey.HighRisk to "خطر عالٍ",
    WebStringKey.HighRiskLabel to "خطر عالٍ",
    WebStringKey.HomographIdnAttack to "هجوم الحروف المتشابهة / IDN",
    WebStringKey.InternationalizedDomainDetected to "تم اكتشاف اسم نطاق دولي.",
    WebStringKey.JustNow to "الآن",
    WebStringKey.KeyboardShortcutsDesc to "اختصارات لوحة المفاتيح للوصول السريع",
    WebStringKey.LiveFeedActive to "البث المباشر نشط",
    WebStringKey.LowRisk to "خطر منخفض",
    WebStringKey.LowRiskLabel to "خطر منخفض",
    WebStringKey.Malicious to "خبيث",
    WebStringKey.MediumRiskLabel to "خطر متوسط",
    WebStringKey.NoData to "لا توجد بيانات",
    WebStringKey.NoScanDataResults to "لا تتوفر بيانات مسح. يرجى مسح رابط لرؤية نتائج التحليل.",
    WebStringKey.NoUrlScanned to "لم يتم مسح رابط",
    WebStringKey.Persian to "الفارسية",
    WebStringKey.PhishingIndicators to "مؤشرات التصيد",
    WebStringKey.ProceedWithCaution to "تابع بحذر",
    WebStringKey.ProceedWithCautionDesc to "تم اكتشاف بعض المؤشرات المشبوهة. تحقق من المصدر قبل إدخال معلومات حساسة.",
    WebStringKey.RealTimeScanningDesc to "المسح في الوقت الفعلي",
    WebStringKey.RedirectShortenerDetected to "تم اكتشاف إعادة توجيه/مختصر",
    WebStringKey.SafeToVisit to "آمن للزيارة",
    WebStringKey.SafeToVisitDesc to "تم التحقق بواسطة الاستدلال المحلي v2.4. لم يتم العثور على أنماط تصيد أو نصوص مشفرة أو تطابقات قائمة سوداء.",
    WebStringKey.SafetyScore to "درجة الأمان",
    WebStringKey.ScanCompleteLabel to "اكتمل المسح",
    WebStringKey.ScanToAnalyze to "امسح رمز QR أو أدخل رابطاً للتحليل.",
    WebStringKey.ScannedURLLabel to "الرابط الممسوح",
    WebStringKey.SecuritySignal to "إشارة أمنية",
    WebStringKey.SensitivityLevelDesc to "مستوى الحساسية",
    WebStringKey.SensitivityPermissive to "متساهل",
    WebStringKey.SensitivityStrict to "صارم",
    WebStringKey.SettingsDetection to "الكشف",
    WebStringKey.SettingsDisplay to "العرض",
    WebStringKey.SettingsLanguage to "اللغة",
    WebStringKey.SettingsLanguageDesc to "اختر لغة واجهة المستخدم",
    WebStringKey.SettingsNotifications to "الإشعارات",
    WebStringKey.SettingsSavedAutomatically to "يتم حفظ الإعدادات تلقائياً ومزامنتها عبر الجلسات.",
    WebStringKey.ShowConfidenceScoreDesc to "إظهار درجة الثقة",
    WebStringKey.SoundAlertsDesc to "التنبيهات الصوتية",
    WebStringKey.SuspiciousDomain to "نطاق مشبوه",
    WebStringKey.SuspiciousEncoding to "ترميز مشبوه",
    WebStringKey.SuspiciousKeywords to "كلمات مشبوهة",
    WebStringKey.SuspiciousTld to "TLD مشبوه",
    WebStringKey.SuspiciousTldDesc to "يستخدم النطاق {tld} TLD المرتبط عادةً بالمواقع الخبيثة.",
    WebStringKey.SuspiciousUrlParams to "معلمات URL مشبوهة",
    WebStringKey.SuspiciousUrlParamsDesc to "يحتوي الرابط على معلمات معقدة أو مشفرة محتملة.",
    WebStringKey.ThreatAlertsDesc to "تنبيهات التهديد",
    WebStringKey.ThreatDetected to "تم اكتشاف تهديد",
    WebStringKey.UnableToDetermine to "تعذر تحديد الحكم. يرجى المحاولة مرة أخرى.",
    WebStringKey.Unknown to "غير معروف",
    WebStringKey.UnknownURL to "رابط غير معروف",
    WebStringKey.UrlShortenerDesc to "يستخدم الرابط خدمة اختصار تخفي الوجهة النهائية.",
    WebStringKey.UrlShortenerDetected to "تم اكتشاف مختصر URL",
    WebStringKey.VersionOfflineReady to "جاهز للعمل دون اتصال",
    WebStringKey.VisualAppearance to "المظهر المرئي",
    WebStringKey.WaitingForAnalysisLabel to "في انتظار التحليل...",

    // Reason Code Titles and Descriptions (for i18n of attack analysis cards)
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "رابط JavaScript",
    WebStringKey.ReasonJavascriptUrlDesc to "تم اكتشاف مخطط JavaScript URL - ينفذ الكود عند النقر",
    WebStringKey.ReasonDataUriTitle to "URI البيانات",
    WebStringKey.ReasonDataUriDesc to "تم اكتشاف مخطط Data URI - قد يحتوي على كود ضار مدمج",
    WebStringKey.ReasonAtSymbolInjectionTitle to "حقن رمز @",
    WebStringKey.ReasonAtSymbolInjectionDesc to "يحتوي الرابط على رمز @ يشير إلى محاولة سرقة بيانات الاعتماد",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "هجوم الحروف المتشابهة",
    WebStringKey.ReasonHomographDesc to "اسم النطاق الدولي (IDN) قد ينتحل نطاقًا آخر",
    WebStringKey.ReasonMixedScriptTitle to "نص مختلط",
    WebStringKey.ReasonMixedScriptDesc to "يحتوي اسم المضيف على أحرف من نصوص متعددة (انتحال محتمل)",
    WebStringKey.ReasonLookalikeCharsTitle to "أحرف متشابهة",
    WebStringKey.ReasonLookalikeCharsDesc to "يحتوي النطاق على أحرف يونيكود تشبه أحرف ASCII",
    WebStringKey.ReasonZeroWidthCharsTitle to "أحرف بعرض صفري",
    WebStringKey.ReasonZeroWidthCharsDesc to "تم اكتشاف أحرف يونيكود مخفية بعرض صفري (محاولة تمويه)",
    WebStringKey.ReasonIpHostTitle to "مضيف IP",
    WebStringKey.ReasonIpHostDesc to "يستخدم الرابط عنوان IP بدلاً من اسم النطاق",
    WebStringKey.ReasonCredentialParamTitle to "معامل بيانات الاعتماد",
    WebStringKey.ReasonCredentialParamDesc to "يحتوي الرابط على معاملات متعلقة ببيانات الاعتماد (كلمة مرور، رمز، إلخ)",
    WebStringKey.ReasonBrandImpersonationTitle to "انتحال العلامة التجارية",
    WebStringKey.ReasonBrandImpersonationDesc to "يبدو أن الرابط ينتحل علامة تجارية معروفة",
    WebStringKey.ReasonBrandInSubdomainTitle to "العلامة التجارية في النطاق الفرعي",
    WebStringKey.ReasonBrandInSubdomainDesc to "يظهر اسم العلامة التجارية في النطاق الفرعي وليس النطاق الرئيسي",
    WebStringKey.ReasonRiskyExtensionTitle to "امتداد محفوف بالمخاطر",
    WebStringKey.ReasonRiskyExtensionDesc to "يحتوي المسار على امتداد ملف خطير محتمل",
    WebStringKey.ReasonDoubleExtensionTitle to "امتداد مزدوج",
    WebStringKey.ReasonDoubleExtensionDesc to "تم اكتشاف امتداد ملف مزدوج (تكتيك برمجيات خبيثة شائع)",
    WebStringKey.ReasonEncodedPayloadTitle to "حمولة مشفرة",
    WebStringKey.ReasonEncodedPayloadDesc to "تم اكتشاف بيانات مشفرة كبيرة في معاملات الرابط",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP وليس HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "يستخدم الرابط بروتوكول HTTP غير الآمن بدلاً من HTTPS",
    WebStringKey.ReasonSuspiciousTldTitle to "TLD مشبوه",
    WebStringKey.ReasonSuspiciousTldDesc to "نطاق المستوى الأعلى يُستخدم بشكل متكرر للتصيد",
    WebStringKey.ReasonHighEntropyHostTitle to "مضيف عالي الإنتروبيا",
    WebStringKey.ReasonHighEntropyHostDesc to "يبدو أن اسم النطاق مُولّد عشوائيًا",
    WebStringKey.ReasonRedirectParamTitle to "معامل إعادة التوجيه",
    WebStringKey.ReasonRedirectParamDesc to "يحتوي الرابط على معامل إعادة توجيه قد يؤدي إلى موقع آخر",
    WebStringKey.ReasonDeepSubdomainTitle to "نطاق فرعي عميق",
    WebStringKey.ReasonDeepSubdomainDesc to "عمق نطاق فرعي مفرط (قد يخفي النطاق الحقيقي)",
    WebStringKey.ReasonMultiTldTitle to "TLD متعدد",
    WebStringKey.ReasonMultiTldDesc to "شرائح متعددة تشبه TLD في اسم النطاق",
    WebStringKey.ReasonNumericSubdomainTitle to "نطاق فرعي رقمي",
    WebStringKey.ReasonNumericSubdomainDesc to "تم اكتشاف نطاق فرعي رقمي فقط",
    WebStringKey.ReasonNonStandardPortTitle to "منفذ غير قياسي",
    WebStringKey.ReasonNonStandardPortDesc to "يستخدم الرابط رقم منفذ غير قياسي",
    WebStringKey.ReasonSuspiciousPortTitle to "منفذ مشبوه",
    WebStringKey.ReasonSuspiciousPortDesc to "يستخدم الرابط منفذًا مرتبطًا عادةً بالهجمات",
    WebStringKey.ReasonFragmentHidingTitle to "إخفاء الجزء",
    WebStringKey.ReasonFragmentHidingDesc to "يبدو أن جزء الرابط يخفي محتوى إضافي",
    WebStringKey.ReasonExcessiveEncodingTitle to "ترميز مفرط",
    WebStringKey.ReasonExcessiveEncodingDesc to "تم اكتشاف ترميز URL مفرط (محاولة تمويه)",
    WebStringKey.ReasonDomainAgePatternTitle to "نمط عمر النطاق",
    WebStringKey.ReasonDomainAgePatternDesc to "يطابق اسم النطاق أنماط النطاقات المُولّدة تلقائيًا",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "مختصر URL",
    WebStringKey.ReasonUrlShortenerDesc to "يستخدم الرابط خدمة اختصار (يخفي الوجهة الحقيقية)",
    WebStringKey.ReasonSuspiciousPathTitle to "مسار مشبوه",
    WebStringKey.ReasonSuspiciousPathDesc to "يحتوي المسار على كلمات مفتاحية مشبوهة (login، verify، إلخ)",
    WebStringKey.ReasonLongUrlTitle to "رابط طويل",
    WebStringKey.ReasonLongUrlDesc to "رابط طويل بشكل غير عادي",
    WebStringKey.ReasonCredentialKeywordsTitle to "كلمات بيانات الاعتماد",
    WebStringKey.ReasonCredentialKeywordsDesc to "يحتوي الرابط على كلمات مفتاحية لجمع بيانات الاعتماد",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "رابط غير قابل للتحليل",
    WebStringKey.ReasonUnparseableDesc to "تعذر تحليل الرابط بالكامل",
    WebStringKey.ReasonAnalysisCompleteTitle to "اكتمل التحليل",
    WebStringKey.ReasonAnalysisCompleteDesc to "اكتمل التحليل بنجاح",

    // ML Score Labels
    WebStringKey.MlPhishingScore to "درجة التصيد ML",
    WebStringKey.MlCharacterAnalysis to "تحليل الأحرف",
    WebStringKey.MlFeatureAnalysis to "تحليل الميزات",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "نطاق IDN / Punycode",
    WebStringKey.IdnPunycodeDomainDesc to "يستخدم هذا النطاق أحرفاً دولية. العرض الآمن:",
    WebStringKey.MixedScriptAttackTitle to "هجوم النصوص المختلطة",
    WebStringKey.MixedScriptAttackDesc to "يحتوي النطاق على أحرف من نصوص متعددة (مثل السيريلية + اللاتينية). شائع في هجمات الأحرف المتشابهة.",
    WebStringKey.ConfusableCharsTitle to "أحرف قابلة للخلط",
    WebStringKey.ConfusableCharsDesc to "يحتوي النطاق على أحرف تشبه الأحرف الشائعة (مثل 'а' مقابل 'a')."
)

internal val ArabicCommonStrings = mapOf(
    "Engine Active" to "المحرك نشط",
    "Enterprise Protection Active" to "حماية المؤسسة نشطة",
    "Start New Scan" to "بدء مسح جديد",
    "Import Image" to "استيراد صورة",
    "System Health" to "صحة النظام",
    "Threat Database" to "قاعدة بيانات التهديدات",
    "Current" to "الحالي",
    "Heuristic Engine" to "المحرك الإستدلالي",
    "Active" to "نشط",
    "Threats" to "التهديدات",
    "Safe Scans" to "المسوحات الآمنة",
    "Recent Scans" to "المسوحات الأخيرة",
    "View Full History" to "عرض السجل الكامل",
    "Status" to "الحالة",
    "Source" to "المصدر",
    "Details" to "التفاصيل",
    "Time" to "الوقت",
    "SAFE" to "آمن",
    "SUSPICIOUS" to "مشبوه",
    "PHISHING" to "تصيد",
    "UNKNOWN" to "غير معروف",
    "Version" to "الإصدار",
    "Last Update" to "آخر تحديث",
    "Signatures" to "التوقيعات",
    "Check for Updates" to "التحقق من التحديثات",
    "Active Scanner" to "الماسح النشط",
    "Offline Mode" to "الوضع غير المتصل",
    "Camera Access Required" to "مطلوب الوصول للكاميرا",
    "Enable Camera" to "تمكين الكاميرا",
    "Scanning..." to "جاري المسح...",
    "Torch" to "المصباح",
    "Gallery" to "المعرض",
    "Paste URL" to "لصق URL",
    "Analyze URL" to "تحليل URL",
    "Analyze" to "تحليل",
    "READY" to "جاهز",
    "Local DB" to "قاعدة بيانات محلية",
    "Latency" to "التأخير",
    "View All" to "عرض الكل",
    "Dashboard" to "لوحة التحكم",
    "Settings" to "الإعدادات",
    "Training Centre" to "مركز التدريب",
    "Beat the Bot" to "تغلب على الروبوت",
    "Safe" to "آمن",
    "Suspicious" to "مشبوه",
    "Dangerous" to "خطير",
    "Phishing" to "تصيد",
    "Legitimate" to "شرعي",
    "Block & Report" to "حظر والإبلاغ",
    "Copy Link" to "نسخ الرابط",
    "Share" to "مشاركة",
    "Export Report" to "تصدير التقرير",
    "Clear All" to "مسح الكل",
    "Cancel" to "إلغاء",
    "Close" to "إغلاق",
    "Back to Dashboard" to "العودة إلى لوحة التحكم",
    "Scan Complete" to "اكتمل المسح",
    "High Risk" to "خطر عالٍ",
    "Low Risk" to "خطر منخفض",
    "Risk Score" to "درجة المخاطر",
    "Confidence" to "الثقة",
    "Homograph Attack" to "هجوم الأحرف المتشابهة",
    "Detected" to "تم الاكتشاف",
    "العربية" to "العربية",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "نشاط مشبوه",
    WebStringKey.VerdictWarning to "تحذير",
    WebStringKey.VerdictSuspiciousDesc to "يُظهر رمز QR الممسوح أنماطًا مشبوهة قد تشير إلى مخاطر أمنية محتملة. تابع بحذر.",
    WebStringKey.VerdictMinorConcerns to "مخاوف طفيفة",
    WebStringKey.VerdictCaution to "تنبيه",
    WebStringKey.VerdictMinorConcernsDesc to "تم تحديد بعض المخاوف الأمنية الطفيفة. يبدو الرابط آمنًا في الغالب لكن يُوصى بالمراجعة.",
    WebStringKey.VerdictVerifiedSafe to "آمن ومُتحقق منه",
    WebStringKey.VerdictSafeLabel to "آمن",
    WebStringKey.VerdictVerifiedSafeDesc to "لم يتم اكتشاف أي تهديدات أمنية. يؤدي رمز QR إلى وجهة آمنة مُتحقق منها.",
    WebStringKey.VerdictNoActivity to "لا يوجد نشاط",
    WebStringKey.VerdictAwaitingScan to "في انتظار المسح",
    WebStringKey.VerdictNoActivityDesc to "لا تتوفر بيانات مسح. يرجى مسح رمز QR أو إدخال عنوان URL للتحليل.",
    WebStringKey.ScanQrToSeeActivity to "امسح رمز QR لرؤية نشاطك هنا",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "نقطة البيانات",
    WebStringKey.ProcessingEnv to "بيئة المعالجة",
    WebStringKey.ExternalTransmission to "النقل الخارجي",
    WebStringKey.RawImageBuffer to "ذاكرة الصورة الخام",
    WebStringKey.LocalMemoryRam to "الذاكرة المحلية (RAM)",
    WebStringKey.TransmissionNone to "لا شيء",
    WebStringKey.DecodedUrlPayload to "URL/المحتوى المفكك",
    WebStringKey.LocalAnalysis to "التحليل المحلي",
    WebStringKey.ThreatVerdictLabel to "حكم التهديد",
    WebStringKey.LocalDatabase to "قاعدة البيانات المحلية"
)
